import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "rinsed:ticket-note-history";
const MAX_ENTRIES = 200;
const MAX_ENTRY_LENGTH = 2000;

export default class extends Controller {
  static targets = ["textarea", "mirror", "typed", "ghost", "hint"];

  connect() {
    this.form = this.element.closest("form");
    if (this.form) this.form.addEventListener("submit", this.persist);
    this.update();
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this.persist);
  }

  input() {
    this.update();
    this.syncScroll();
  }

  syncScroll() {
    this.mirrorTarget.scrollTop = this.textareaTarget.scrollTop;
  }

  keydown(event) {
    if (event.key === "Tab" && this.suggestion) {
      event.preventDefault();
      this.textareaTarget.value = this.suggestion;
      const end = this.suggestion.length;
      this.textareaTarget.setSelectionRange(end, end);
      this.update();
    }
  }

  update() {
    const ta = this.textareaTarget;
    const value = ta.value;
    const atEnd = ta.selectionStart === value.length && ta.selectionEnd === value.length;
    const match = value && atEnd ? findCompletion(value) : null;
    this.suggestion = match;
    this.typedTarget.textContent = value;
    this.ghostTarget.textContent = match ? match.slice(value.length) : "";
    this.hintTarget.textContent = match ? " (press tab to autocomplete)" : "";
  }

  persist = () => {
    addToHistory(this.textareaTarget.value);
  };
}

function readHistory() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

function addToHistory(value) {
  const v = value.trim();
  if (!v || v.length > MAX_ENTRY_LENGTH) return;
  const arr = readHistory().filter((x) => x !== v);
  arr.unshift(v);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_ENTRIES)));
  } catch {
    // quota exceeded — drop silently
  }
}

function findCompletion(prefix) {
  const lower = prefix.toLowerCase();
  for (const entry of readHistory()) {
    if (entry.length > prefix.length && entry.toLowerCase().startsWith(lower)) {
      return entry;
    }
  }
  return null;
}
